<template>
  <div class="home">
    <!-- 可通过className设置样式 -->
    <!-- <dept-member
      v-if="show"
      v-model="dmList"
      style="width:600px;"
      :init-dept-list="initDeptList"
      :init-member-list="initMemberList"
    /> -->
    <img
      src="http://cf-qw-1256732272.cos.ap-shanghai.myqcloud.com/wwpic/784139_7e6ZE3DcSoSobKk_1592487549/0'"
      alt=""
    >
    <mk-button @click="click1">
      下载图片
    </mk-button>
    <mk-button @click="click2">
      下载模板
    </mk-button>
    <!-- {{ dmList }} -->
    <!-- initDeptList: 初始部门列表 -->
    <!-- use-select: 是否需要select -->
    <!-- can-select-company: 公司是否可选 -->
    <!-- canSelectDept: 部门是否可以被选择 -->
    <!-- isSingle: 是否是单选 -->
    <!-- 公司id为NA，根据需要自行转换 -->
    <!-- <dept-member-select-biz
      v-model="dmList"
      :can-select-company="true"
    />
    <export-xlsx-btn :api="api" /> -->
    <!-- canSelectDept: 部门是否可以被选择 -->
    <!-- <dept-member-select
      v-model="dmList"
      :can-select-dept="false"
    /> -->

    <!-- 单人选择 -->
    <!-- <dept-member-select
      v-model="dmList"
      is-single
    /> -->
    <!-- <mk-button-biz
      width="260px"
      height="38px"
      @click="handleGuage"
    >
      修改仪表盘数据
    </mk-button-biz>
    <mk-guage
      :data="guageData"
      :options="guageConfig"
    >
    </mk-guage> -->
    <!-- 面积层叠图，精确到年 -->
    <!-- <mk-stacked
      :data="stackedData3"
      :options="ssoptions3"
    >
    </mk-stacked> -->
    <!-- 面积层叠图，精确到月 -->
    <!-- <mk-stacked
      :data="stackedData2"
      :options="ssoptions2"
    >
    </mk-stacked> -->
    <!-- 面积层叠图，精确到日 -->
    <!-- <mk-stacked
      :data="stackedData"
      :options="ssoptions"
    >
    </mk-stacked> -->
    <!-- <mk-pie
      :data="pieData"
      :options="pieOptions"
      :transform="pieTransform"
    ></mk-pie>
    <mk-bar :data="stackedData">
    </mk-bar> -->
    <!-- 折线图预览 -->
    <!-- <mk-stacked
      :data="brokenData"
      :options="soptions"
    >
    </mk-stacked> -->
  </div>
</template>

<script>
import { ACCOUNTAPIS } from '@api'
import exportXlsxBtn from '@components/export-xlsx'
import deptMemberSelectBiz from '@components/dept-member-select-biz'
export default {
  name: 'Home',
  components: {
    // deptMemberSelectBiz,
    // exportXlsxBtn
  },
  data () {
    return {
      api: {
        name: BIZAPIS.ExportApi.exportFormGet,
        params: {
          formId: 'c1e28b01-5f54-11ea-a733-bef438026e85',
          formIds: '5e8f309a6316823a9ddc87cc'
        }
      },
      show: false,
      initDeptList: [],
      initMemberList: [],
      dmList: {
        // 部门列表
        dept: [
          {
            id: 'c7ccd8e4-fa00-11e9-aea3-0242ac110002',
            name: '前端'
          }
        ],
        // 成员列表
        member: [
          {
            id: '16e7d809-e9b5-11e9-be2b-0242ac110003',
            name: '营销前端研发'
          }
        ]
      },
      guageData: [
        {
          type: '覆盖客户',
          value: 30
        }
      ],
      guageConfig: {
        chart: {
          width: 150,
          height: 150,
          scale: {
            value: {
              min: 0,
              // 最大值
              max: 1000,
              tickInterval: 0,
              nice: false
            }
          }
        }
      },
      pieOptions: {
        chart: {
          width: 600,
          height: 400
        },
        coord: {
          innerRadius: 0.5
        },
        html: {
          text: '线索数',
          subtext: 100,
          unit: '人'
        }
      },
      pieTransform: {
        type: 'percent',
        field: 'count',
        dimension: 'item',
        as: 'percent'
      },
      pieData: [
        { item: '事例一', count: 40 },
        { item: '事例二', count: 21 },
        { item: '事例三', count: 17 },
        { item: '事例四', count: 13 },
        { item: '事例五', count: 9 }
      ],
      soptions: {
        chart: {
          height: 400,
          padding: [50, 50, 50, 50],
          scale: {
            year: {
              range: [0, 1]
            }
          }
        },
        axis: [
          {
            name: 'year'
          },
          {
            name: 'value'
          }
        ],
        geom: [
          {
            type: 'point',
            position: 'year*value', // 对于数据的year,value
            color: 'city' // 对于数据的city
          },
          {
            type: 'line',
            position: 'year*value',
            color: 'city'
          }
        ]
      },
      ssoptions: {
        chart: {
          height: 400,
          width: 600,
          padding: [50, 50, 50, 50],
          scale: {
            year: {
              type: 'time',
              mask: 'YYYY-MM-DD',
              tickInterval: 24 * 3600 * 1000 * 1
            }
          }
        },
        axis: [
          {
            dataTime: 'year'
          },
          {
            name: 'value'
          }
        ],
        geom: [
          {
            type: 'area',
            position: 'year*value',
            color: 'country'
          },
          {
            type: 'line',
            position: 'year*value',
            color: 'country',
            size: 2
          }
        ]
      },
      stackedData: [
        {
          country: 'Asia',
          year: new Date(new Date('2019-10-01').getTime()).getTime(),
          value: 502
        },
        { country: 'Asia', year: new Date('2019-10-02').getTime(), value: 635 },
        { country: 'Asia', year: new Date('2019-10-03').getTime(), value: 809 },
        {
          country: 'Asia',
          year: new Date('2019-10-04').getTime(),
          value: 5268
        },
        {
          country: 'Asia',
          year: new Date('2019-10-05').getTime(),
          value: 4400
        },
        {
          country: 'Asia',
          year: new Date('2019-10-06').getTime(),
          value: 3634
        },
        { country: 'Asia', year: new Date('2019-10-07').getTime(), value: 947 },
        {
          country: 'Africa',
          year: new Date('2019-10-01').getTime(),
          value: 106
        },
        {
          country: 'Africa',
          year: new Date('2019-10-02').getTime(),
          value: 107
        },
        {
          country: 'Africa',
          year: new Date('2019-10-03').getTime(),
          value: 111
        },
        {
          country: 'Africa',
          year: new Date('2019-10-04').getTime(),
          value: 1766
        },
        {
          country: 'Africa',
          year: new Date('2019-10-05').getTime(),
          value: 221
        },
        {
          country: 'Africa',
          year: new Date('2019-10-06').getTime(),
          value: 767
        },
        {
          country: 'Africa',
          year: new Date('2019-10-07').getTime(),
          value: 133
        },
        {
          country: 'Europe',
          year: new Date('2019-10-01').getTime(),
          value: 163
        },
        {
          country: 'Europe',
          year: new Date('2019-10-02').getTime(),
          value: 203
        },
        {
          country: 'Europe',
          year: new Date('2019-10-03').getTime(),
          value: 276
        },
        {
          country: 'Europe',
          year: new Date('2019-10-04').getTime(),
          value: 628
        },
        {
          country: 'Europe',
          year: new Date('2019-10-05').getTime(),
          value: 547
        },
        {
          country: 'Europe',
          year: new Date('2019-10-06').getTime(),
          value: 729
        },
        {
          country: 'Europe',
          year: new Date('2019-10-07').getTime(),
          value: 408
        },
        {
          country: 'Oceania',
          year: new Date('2019-10-01').getTime(),
          value: 200
        },
        {
          country: 'Oceania',
          year: new Date('2019-10-02').getTime(),
          value: 200
        },
        {
          country: 'Oceania',
          year: new Date('2019-10-03').getTime(),
          value: 200
        },
        {
          country: 'Oceania',
          year: new Date('2019-10-04').getTime(),
          value: 460
        },
        {
          country: 'Oceania',
          year: new Date('2019-10-05').getTime(),
          value: 230
        },
        {
          country: 'Oceania',
          year: new Date('2019-10-06').getTime(),
          value: 300
        },
        {
          country: 'Oceania',
          year: new Date('2019-10-07').getTime(),
          value: 300
        }
      ],
      ssoptions2: {
        chart: {
          height: 400,
          padding: [50, 50, 50, 50],
          scale: {
            year: {
              type: 'timeCat',
              range: [0, 1],
              mask: 'YYYY-MM',
              tickCount: 12 // 显示<=12的所有数据
            }
          }
        },
        axis: [
          {
            dataTime: 'year'
            // name: 'year'
          },
          {
            name: 'value'
          }
        ],
        geom: [
          {
            type: 'area',
            position: 'year*value',
            color: 'country'
          },
          {
            type: 'line',
            position: 'year*value',
            color: 'country'
          }
        ]
      },
      stackedData2: [
        {
          country: 'Asia',
          year: new Date('2019-1').getTime(),
          value: 502
        },
        {
          country: 'Asia',
          year: new Date('2019-2').getTime(),
          value: 635
        },
        {
          country: 'Asia',
          year: new Date('2019-3').getTime(),
          value: 809
        },
        {
          country: 'Asia',
          year: new Date('2019-4').getTime(),
          value: 5268
        },
        {
          country: 'Asia',
          year: new Date('2019-5').getTime(),
          value: 4400
        },
        {
          country: 'Asia',
          year: new Date('2019-6').getTime(),
          value: 3634
        },
        {
          country: 'Asia',
          year: new Date('2019-7').getTime(),
          value: 947
        },
        {
          country: 'Africa',
          year: new Date('2019-1').getTime(),
          value: 106
        },
        {
          country: 'Africa',
          year: new Date('2019-2').getTime(),
          value: 107
        },
        {
          country: 'Africa',
          year: new Date('2019-3').getTime(),
          value: 111
        },
        {
          country: 'Africa',
          year: new Date('2019-4').getTime(),
          value: 1766
        },
        {
          country: 'Africa',
          year: new Date('2019-5').getTime(),
          value: 221
        },
        {
          country: 'Africa',
          year: new Date('2019-6').getTime(),
          value: 767
        },
        {
          country: 'Africa',
          year: new Date('2019-7').getTime(),
          value: 133
        }
      ],
      ssoptions3: {
        chart: {
          height: 400,
          padding: [50, 50, 50, 50],
          scale: {
            year: {
              type: 'linear'
            }
          }
        },
        axis: [
          {
            name: 'year'
          },
          {
            name: 'value'
          }
        ],
        geom: [
          {
            type: 'area',
            position: 'year*value',
            color: 'country'
          },
          {
            type: 'line',
            position: 'year*value',
            color: 'country'
          }
        ]
      },
      stackedData3: [
        {
          country: 'Asia',
          year: '2009',
          value: 502
        },
        {
          country: 'Asia',
          year: '2010',
          value: 635
        },
        {
          country: 'Asia',
          year: '2012',
          value: 809
        },
        {
          country: 'Asia',
          year: '2013',
          value: 5268
        },
        {
          country: 'Asia',
          year: '2014',
          value: 4400
        },
        {
          country: 'Asia',
          year: '2015',
          value: 3634
        },
        {
          country: 'Asia',
          year: '2016',
          value: 947
        },
        {
          country: 'Africa',
          year: '2009',
          value: 106
        },
        {
          country: 'Africa',
          year: '2010',
          value: 107
        },
        {
          country: 'Africa',
          year: '2011',
          value: 111
        },
        {
          country: 'Africa',
          year: '2012',
          value: 1766
        },
        {
          country: 'Africa',
          year: '2013',
          value: 221
        },
        {
          country: 'Africa',
          year: '2014',
          value: 767
        },
        {
          country: 'Africa',
          year: '2015',
          value: 133
        },
        {
          country: 'Africa',
          year: '2016',
          value: 333
        }
      ],
      brokenData: [
        {
          year: 'Jan',
          city: 'China',
          value: 7
        },
        {
          year: 'Jan',
          city: 'Oversea',
          value: 3.9
        },
        {
          year: 'Feb',
          city: 'China',
          value: 6.9
        },
        {
          year: 'Feb',
          city: 'Oversea',
          value: 4.2
        },
        {
          year: 'Mar',
          city: 'China',
          value: 9.5
        },
        {
          year: 'Mar',
          city: 'Oversea',
          value: 5.7
        },
        {
          year: 'Apr',
          city: 'China',
          value: 14.5
        },
        {
          year: 'Apr',
          city: 'Oversea',
          value: 8.5
        },
        {
          year: 'May',
          city: 'China',
          value: 18.4
        },
        {
          year: 'May',
          city: 'Oversea',
          value: 11.9
        },
        {
          year: 'Jun',
          city: 'China',
          value: 21.5
        },
        {
          year: 'Jun',
          city: 'Oversea',
          value: 15.2
        },
        {
          year: 'Jul',
          city: 'China',
          value: 25.2
        },
        {
          year: 'Jul',
          city: 'Oversea',
          value: 17
        },
        {
          year: 'Aug',
          city: 'China',
          value: 26.5
        },
        {
          year: 'Aug',
          city: 'Oversea',
          value: 16.6
        },
        {
          year: 'Sep',
          city: 'China',
          value: 23.3
        },
        {
          year: 'Sep',
          city: 'Oversea',
          value: 14.2
        },
        {
          year: 'Oct',
          city: 'China',
          value: 18.3
        },
        {
          year: 'Oct',
          city: 'Oversea',
          value: 10.3
        },
        {
          year: 'Nov',
          city: 'China',
          value: 13.9
        },
        {
          year: 'Nov',
          city: 'Oversea',
          value: 6.6
        },
        {
          year: 'Dec',
          city: 'China',
          value: 9.6
        },
        {
          year: 'Dec',
          city: 'Oversea',
          value: 4.8
        }
      ]
    }
  },
  created () {
    this.getDeptList()
  },
  methods: {
    click1 () {
      // http://cf-qw.oss-cn-hangzhou.aliyuncs.com/wwpic/576732_qbPUGC7UT6ardD2_1592392702/0
      this.util.downloadImage({
        // href: 'http://cf-qw-1256732272.cos.ap-shanghai.myqcloud.com/wwpic/784139_7e6ZE3DcSoSobKk_1592487549/0'
        href: 'http://cf-qw.oss-cn-hangzhou.aliyuncs.com/wwpic/576732_qbPUGC7UT6ardD2_1592392702/0'
      })
    },
    click2 () {
      this.util.download({
        href: location.origin + '/企业常用语导入模板.xlsx'
      })
    },
    handleGuage () {
      this.guageData = [
        {
          type: '覆盖客户',
          value: 50
        }
      ]
    },
    async getDeptList () {
      // 获取部门信息
      const res = await ACCOUNTAPIS.OrganisationApi.v1OrganisationFindDepListGet()
      if (res.success) {
        this.initDeptList = res.data
        this.getMembList()
        // window.localStorage.setItem('departMemberDeptList', JSON.stringify(res.data))
      }
    },
    async getMembList () {
      // 获取成员列表
      const res = await ACCOUNTAPIS.OrganisationApi.v1OrganisationAllGet()
      if (res.success) {
        this.initMemberList = res.data
        this.show = true
        // localStorage.setItem('departMemberList', JSON.stringify(res.data))
      }
    }
  }
}
</script>
